import { ClientConfig } from '../config/ClientConfig'
import { Injector } from '../injector/Injector'
import { HttpService } from '../communication/ajax-helpers'
import { Observable } from 'rxjs'

export class UserApiService {

	private readonly baseUrl: string
	private readonly jsonSettings: {}
	private httpService: HttpService

	constructor() {
		this.baseUrl = ClientConfig.USERAPI_BASE_URL
		this.httpService = Injector.get(HttpService)
		this.jsonSettings = {
			contentType: 'application/json',
			xhrFields: {
				withCredentials: true
			},
			crossDomain: true
		}
	}

	httpGet<T = {}>(url: string): Observable<T> {
		return this.httpService.http(this.baseUrl + url, {
			...this.jsonSettings,
			type: 'GET',
		})
	}

	httpPost<T = {}, R = {}>(url: string, data: T, overloadedJsonSettings?: object): Observable<R> {
		return this.httpService.http(this.baseUrl + url, {
			...this.jsonSettings,
			...overloadedJsonSettings,
			type: 'POST',
			data: JSON.stringify(data),
		})
	}

	httpPut<T = {}, R = {}>(url: string, data: T): Observable<R> {
		return this.httpService.http(this.baseUrl + url, {
			...this.jsonSettings,
			type: 'PUT',
			data: JSON.stringify(data),
		})
	}

	httpDelete<T = void>(url: string): Observable<T> {
		return this.httpService.http(this.baseUrl + url, {
			contentType: 'application/json',
			xhrFields: {
				withCredentials: true
			},
			crossDomain: true,
			type: 'DELETE',
		})
	}
}
